module.exports = __webpack_public_path__ + "img/cert-iso-9001.354a969f.jpg";